// The password sign-in asks a reCAPTCHA on production only, as the dashboard, backoffice and Pay
// do: api-next verifies a sign-in captcha on production only (`isCaptchaEnforced()`), so dev,
// staging and demo show no widget and send no field. It also takes a build (NODE_ENV is
// 'development' for every `yarn start:*`): `start:production` and `start:local:production` source a
// production env file but serve from localhost, where the production site key does not render, and
// the local API behind the latter asks no captcha. A build without a site key shows none either.
// All three variables are inlined at build time, so outside production this is a constant `false`.
export const isSignInCaptchaEnabled = () =>
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_ENV === 'production' &&
  Boolean(process.env.REACT_APP_CAPTCHA_KEY)



// WEBPACK FOOTER //
// ./src/utils/captcha.js